import React from 'react'
import PackageDetails from '../../common/package/packageDetails/index'

export default class ClientPackageDetail extends React.Component{

    constructor(props){
        super()
    }
    render(){
        return(
         
            <PackageDetails match={this.props.match} />
              
            
        )
    }
}